// GET DATA UPCOMING EVENT
export const GET_POPULAR_EVENT_REQUEST = 'GET_POPULAR_EVENT_REQUEST'
export const GET_POPULAR_EVENT_FAILED = 'GET_POPULAR_EVENT_FAILED'
export const GET_POPULAR_EVENT_SUCCESS = 'GET_POPULAR_EVENT_SUCCESS'

    